import React, { useState, useEffect } from 'react'

import { Col, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import HTMLWidget from '../../HTMLWidget'
import InputCheckboxForm from '../../../components/forms/input/InputCheckboxForm'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { setAlertMessage } from '../../../utils/messageUtil'
import { saveFormProjectGrantee } from '../../../redux/actions/subProjectProposal'
import CustomAlertMessage from '../../CustomAlertMessage'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'

export default function ProjectGranteeWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, onReLoadResponsibler } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [receiveByCompany, setReceiveByCompany] = useState(props.schema?.receiveByCompany?.value)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectGrantee(subProjectId, request)
      if (response) {
        setFormSchema(response)
        if (typeof onReLoadResponsibler === 'function') {
          onReLoadResponsibler()
        }
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    // console.log('data', data)

    let values = []
    let subForm = []

    if (formSchema.receiveByCompany) {
      let receiveByCompanyValue = receiveByCompany?.includes('1') ? '1' : '0'

      values.push({
        //key: e.id,
        name: formSchema.receiveByCompany.name,
        value: receiveByCompanyValue,
        //type: e.type,
      })

      formSchema.companyOptions?.forEach((e) => {
        values.push({
          key: e.id,
          name: e.name,
          value: data[e.name] || null,
          type: e.type,
        })
      })
    }

    formSchema.objects?.forEach((e) => {
      if (e.type == 'HEADER_LABEL' || e.type == 'LABEL') {
        //ไม่ทำอะไร
      } else if (e.type == 'ADDRESS') {
        e.subSchemas?.forEach((se) => {
          if (se.sameAddress && data[se.sameAddress.name] != '0') {
            var sameValue = data[se.sameAddress.name]

            subForm.forEach((sev) => {
              if (
                sev.typeId == e.id &&
                (sev.values[0].key == sameValue ||
                  sev.values.find((e) => e.name == 'otherRefers' && e.value == sameValue))
              ) {
                sev.values.push({
                  //key: se.typeId,
                  name: 'otherRefers',
                  value: se.typeId,
                  //type: seo.type,
                })
              }
            })
          } else {
            let subValues = []

            se.objects?.forEach((seo) => {
              subValues.push({
                key: se.typeId,
                name: seo.name,
                value: data[seo.name] || null,
                type: seo.type,
              })
            })

            subForm.push({
              id: se.id,
              typeId: e.id,
              values: subValues,
            })
          }
        })
      } else {
        values.push({
          key: e.id,
          name: e.name,
          value: data[e.name] || null,
          type: e.type,
        })
      }
    })

    let request = {
      id: formSchema.id,
      values: values,
      subForm: subForm,
    }

    //console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {isEdit && showCommandButton ? (
        <div style={{ marginTop: -10 }}>
          {formSchema.description && (
            <Row style={{ marginBottom: 10 }}>
              <CustomAlertMessage contents={formSchema.description} />
            </Row>
          )}

          {formSchema.receiveByCompany && (
            <Panel style={{ marginBottom: -20 }}>
              <Row>
                <Col>
                  <InputRadioForm
                    schema={formSchema.receiveByCompany}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    onChange={(value) => {
                      setReceiveByCompany(value || [])
                    }}
                  />
                </Col>
              </Row>
            </Panel>
          )}

          {receiveByCompany == '1' && formSchema.companyOptions?.length > 0 && (
            <>
              <EditFormWidget
                ignoreDesc
                schema={formSchema}
                objectDatas={formSchema.companyOptions}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                setLoading={setIsLoading}
              />
            </>
          )}

          <EditFormWidget
            ignoreDesc
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            setLoading={setIsLoading}
          />
        </div>
      ) : (
        <div style={{ marginTop: -10 }}>
          {receiveByCompany && formSchema.companyOptions?.length > 0 && (
            <>
              {/* <>{formSchema.receiveByCompany?.options?.find((e) => e.value == '1')?.label}</> */}
              <ViewFormWidget
                schema={formSchema}
                objectDatas={[
                  { ...formSchema.receiveByCompany, type: 'DOPDOWN' },
                  ...(receiveByCompany == '1' ? formSchema.companyOptions : []),
                ]}
              />
            </>
          )}

          <ViewFormWidget schema={formSchema} />
        </div>
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
